"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleVehicleLengthAndRegistrationNumberCheckWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var MultipleVehicleLengthAndRegistrationNumberCheckWidget = exports.MultipleVehicleLengthAndRegistrationNumberCheckWidget = /** @class */ (function (_super) {
    __extends(MultipleVehicleLengthAndRegistrationNumberCheckWidget, _super);
    function MultipleVehicleLengthAndRegistrationNumberCheckWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.removeVehicle = function (registrationNumber) {
            var removedVehicleCount = _this.state.vehiclesToRemoveCount;
            var vehiclesRemovedManually = 0;
            _this.handleVehicleRemoving(registrationNumber);
            removedVehicleCount--;
            vehiclesRemovedManually++;
            _this.setState({
                vehiclesToRemoveCount: removedVehicleCount,
                vehiclesRemovedManuallyCount: vehiclesRemovedManually
            });
        };
        var interaction = _this.props.interaction;
        var totalVehicleCount = _this.totalVehicleCount();
        var duplicateVehicles = _this.getDuplicateVehicles();
        var vehiclesInSubscription = interaction.uistate.policyVehicleRegistrationNumbers.length;
        _this.state = {
            duplicateVehiclesInQuote: duplicateVehicles,
            totalVehicleCountInQuoteAndSubscription: totalVehicleCount,
            vehicleToRemove: "",
            subscriptionVehicleCount: vehiclesInSubscription,
            isDuplicateVehiclesRemoved: false,
            duplicateVehiclesRemoved: 0,
            vehiclesToRemoveCount: totalVehicleCount === 4 ? 1 : 2,
            vehiclesRemovedManuallyCount: 0
        };
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        return _this;
    }
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.renderMoreThanThreeTotalVehiclesContent = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("h3", { className: "text-center mt-3 mb-5 multiple-vehicle-check-header-text" }, "You already have 3 cars under your subscription, go to your account to manage cars under your subscription.")));
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.componentDidMount = function () {
        if (this.state.subscriptionVehicleCount < 3 && this.state.duplicateVehiclesInQuote && (this.state.duplicateVehiclesInQuote.length !== this.props.interaction.vehicles.length)) {
            this.removeDuplicateVehicles(this.state.duplicateVehiclesInQuote);
        }
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.render = function () {
        return (React.createElement("div", { className: "panel" },
            this.state.subscriptionVehicleCount === 3 && MultipleVehicleLengthAndRegistrationNumberCheckWidget.renderMoreThanThreeTotalVehiclesContent(),
            this.state.subscriptionVehicleCount < 3 && !this.state.isDuplicateVehiclesRemoved && (this.state.subscriptionVehicleCount === this.props.interaction.vehicles.length)
                && (this.state.subscriptionVehicleCount === this.state.duplicateVehiclesInQuote.length) && this.renderSubscriptionVehiclesSameAsDuplicateInQuoteContent(),
            this.state.subscriptionVehicleCount < 3 && !this.state.isDuplicateVehiclesRemoved && this.state.duplicateVehiclesInQuote.length === 0 && this.renderNoDuplicateCarsButMoreThanLimitAllowedContent(),
            this.state.subscriptionVehicleCount < 3 && this.state.isDuplicateVehiclesRemoved && this.renderMoreThanAllowedAndIncludingDuplicateVehiclesContent(),
            this.continueButton()));
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.handleOnChangeEvent = function (event) {
        this.setState({ vehicleToRemove: event.target.value });
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.continueButton = function () {
        var continueButton = document.getElementsByClassName("btn-primary btn-next").item(0);
        if (continueButton) {
            this.state.totalVehicleCountInQuoteAndSubscription > 3 ? continueButton.disabled = true : continueButton.disabled = false;
        }
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.getDuplicateVehicles = function () {
        var policyRegistrationNumbers = this.props.interaction.uistate.policyVehicleRegistrationNumbers;
        var interactionVehicles = this.props.interaction.vehicles;
        return (0, commonFunctions_1.getDuplicateCars)(interactionVehicles, policyRegistrationNumbers);
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.totalVehicleCount = function () {
        return this.props.interaction.uistate.policyVehicleRegistrationNumbers.length + this.props.interaction.vehicles.length;
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.removeDuplicateVehicles = function (duplicates) {
        var _this = this;
        if (duplicates && duplicates.length !== 0) {
            var vehiclesRemoved_1 = 0;
            duplicates.forEach(function (car) {
                _this.handleVehicleRemoving(car.registrationNumber);
                vehiclesRemoved_1++;
            });
            this.setState({
                isDuplicateVehiclesRemoved: true,
                duplicateVehiclesRemoved: vehiclesRemoved_1
            });
        }
        else {
            return;
        }
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.handleVehicleRemoving = function (registrationNumber) {
        var vehicleToRemove = this.props.interaction.vehicles.findIndex(function (vehicle) {
            return vehicle.registrationNumber === registrationNumber;
        });
        this.props.interaction.vehicles.splice(vehicleToRemove, 1);
        this.props.interaction.numberOfVehicles = this.props.interaction.numberOfVehicles - 1;
        this.executeEvent("change");
        var totalVehicleCount = this.totalVehicleCount();
        this.setState({
            totalVehicleCountInQuoteAndSubscription: totalVehicleCount
        });
        this.changelogRecorder.recordPage("change", this.props, "vehicles");
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.renderSubscriptionVehiclesSameAsDuplicateInQuoteContent = function () {
        var duplicateVehicles = this.state.duplicateVehiclesInQuote;
        return (React.createElement(React.Fragment, null,
            React.createElement("h3", { className: "multiple-vehicle-check-header-text multiple-cars-h3 mb-0" }, "Cars:"),
            React.createElement("ul", { className: "multiple-vehicle-check-header-text mb-0" },
                React.createElement("li", { className: "multiple-car-li" },
                    duplicateVehicles[0].make,
                    ", ",
                    duplicateVehicles[0].model,
                    " (",
                    duplicateVehicles[0].registrationNumber,
                    ")"),
                React.createElement("li", { className: "multiple-car-li" },
                    duplicateVehicles[1].make,
                    ", ",
                    duplicateVehicles[1].model,
                    " (",
                    duplicateVehicles[1].registrationNumber,
                    ")")),
            React.createElement("h3", { className: "multiple-vehicle-check-header-text multiple-cars-h3" }, "are already covered under your subscription, go to your account to manage your cars.")));
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.renderNoDuplicateCarsButMoreThanLimitAllowedContent = function () {
        var warningMessage = React.createElement("h3", { className: "text-center mt-3 mb-5 multiple-vehicle-check-header-text" },
            "You already have ",
            React.createElement("b", null, this.state.subscriptionVehicleCount),
            " ",
            this.state.subscriptionVehicleCount === 1 ? "car" : "cars",
            " under your subscription, you need to remove",
            ' ',
            React.createElement("b", null, this.state.vehiclesToRemoveCount),
            " cars from your quote to proceed.");
        return (React.createElement(React.Fragment, null, this.renderSelectVehiclesToRemove(warningMessage)));
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.renderMoreThanAllowedAndIncludingDuplicateVehiclesContent = function () {
        var warningMessage;
        var duplicateVehicles = this.state.duplicateVehiclesInQuote;
        if (this.state.duplicateVehiclesRemoved === 2 && this.props.interaction.vehicles.length === 1) {
            warningMessage =
                React.createElement("h3", { className: "text-center mt-3 mb-5 multiple-vehicle-check-header-text" },
                    "Car ",
                    React.createElement("b", null, duplicateVehicles[0].registrationNumber),
                    ", car ",
                    React.createElement("b", null, duplicateVehicles[1].registrationNumber),
                    " are already covered under your subscription so we removed them from your quote.");
            return (React.createElement(React.Fragment, null, warningMessage));
        }
        else if ((this.state.duplicateVehiclesRemoved === 1 && (this.props.interaction.vehicles.length === 2 && this.state.subscriptionVehicleCount === 2)) ||
            (this.state.duplicateVehiclesRemoved === 1 && this.state.vehiclesRemovedManuallyCount === 1)) {
            warningMessage = React.createElement("h3", { className: "text-center mt-3 mb-5 multiple-vehicle-check-header-text" },
                "Car ",
                React.createElement("b", null, duplicateVehicles[0].registrationNumber),
                " is already covered under your subscription so we removed it from your quote.",
                ' ',
                "But because you already have ",
                React.createElement("b", null, this.state.subscriptionVehicleCount),
                " ",
                this.state.subscriptionVehicleCount === 1 ? "car" : "cars",
                " under your subscription, you need to remove at least one car from your quote to proceed.");
            return (React.createElement(React.Fragment, null, this.renderSelectVehiclesToRemove(warningMessage)));
        }
        else {
            warningMessage = React.createElement("h3", { className: "text-center mt-3 mb-5 multiple-vehicle-check-header-text" },
                "Car ",
                React.createElement("b", null, duplicateVehicles[0].registrationNumber),
                " is already covered under your subscription so we removed it from your quote.",
                ' ');
            return (React.createElement(React.Fragment, null, warningMessage));
        }
    };
    MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype.renderSelectVehiclesToRemove = function (message) {
        var _this = this;
        var vehiclesToRender = this.props.interaction.vehicles.map(function (vehicle, i) { return (React.createElement("option", { key: i, value: vehicle.registrationNumber }, vehicle.registrationNumber)); });
        var disabled = vehiclesToRender.length === 0 || this.state.totalVehicleCountInQuoteAndSubscription === 3;
        return (React.createElement(React.Fragment, null,
            message,
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "existingCars" }, "Please choose one of the existing vehicles to remove"),
                React.createElement("div", { className: "input-group" },
                    React.createElement("select", { className: "form-control", onChange: this.handleOnChangeEvent, disabled: disabled, id: "existingCars" },
                        React.createElement("option", { value: '' }, "Please select..."),
                        vehiclesToRender))),
            React.createElement("button", { type: "button", className: "btn btn-primary btn-add remove-vehicle-button-width", disabled: this.state.vehicleToRemove === "" || disabled, onClick: function () { return _this.removeVehicle(_this.state.vehicleToRemove); }, id: "removeVehicle" }, "Remove vehicle")));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], MultipleVehicleLengthAndRegistrationNumberCheckWidget.prototype, "changelogRecorder", void 0);
    return MultipleVehicleLengthAndRegistrationNumberCheckWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=MultipleVehicleLengthAndRegistrationNumberCheckWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/MultipleVehicleLengthAndRegistrationNumberCheckWidget.js
// module id = 2606
// module chunks = 0